import Vue from 'vue'
import App from './App.vue'
import router from './router'
import * as firebase from 'firebase/app';
import VueMoment from 'vue-moment'

Vue.config.productionTip = false
Vue.use(require('vue-moment'));

var config = {
  // production :{
  //   apiKey: "AIzaSyDKja18xDn01F-Yiijk_RmEw9zwDregWJs",
  //   authDomain: "chat-leon-67e72.firebaseapp.com",
  //   databaseURL: "https://chat-leon-67e72.firebaseio.com",
  //   projectId: "chat-leon-67e72",
  //   storageBucket: "",
  //   messagingSenderId: "928290664177"
  // },
  production :{
    apiKey: "AIzaSyAZB-RPmKkODhnr8k87-8A59uqKIxbuMoI",
    authDomain: "chat-salud.firebaseapp.com",
    databaseURL: "https://chat-salud.firebaseio.com",
    projectId: "chat-salud",
    storageBucket: "chat-salud.appspot.com",
    messagingSenderId: "526468264073",
    appId: "1:526468264073:web:e992c37922aa94b3c9d658"
  },
  development:{
    apiKey: "AIzaSyBFmrdYhxUUneNUl_6t6oP54Ldp0feqFUY",
    authDomain: "chat-dev-e8e4d.firebaseapp.com",
    databaseURL: "https://chat-dev-e8e4d.firebaseio.com",
    projectId: "chat-dev-e8e4d",
    storageBucket: "",
    //messagingSenderId: "928290664177"
  }
};
firebase.initializeApp(config.production);
//firebase.initializeApp(config.development);

new Vue({
  router, firebase,
  render: h => h(App),
}).$mount('#app')



